import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const LoadingScreen = () => {
  const [isLoading, setIsLoading] = useState(true);
  const isDarkMode = document.body.classList.contains('dark-mode');

  useEffect(() => {
    // Simulamos un tiempo de carga mínimo para que la animación se vea bien
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="loading-screen"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: isDarkMode ? '#1a1a1a' : '#ffffff',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0, rotate: -180 }}
            animate={{ 
              scale: 1, 
              opacity: 1, 
              rotate: 0,
            }}
            transition={{
              duration: 1,
              ease: "easeOut",
              rotate: {
                duration: 1.2,
                ease: "easeOut"
              }
            }}
            style={{
              marginBottom: '2rem',
              width: '120px',
              height: '120px'
            }}
          >
            <img 
              src="/images/Logo-unalome-02.png" 
              alt="Unalome Logo"
              style={{ 
                width: '100%',
                height: '100%',
                objectFit: 'contain'
              }} 
            />
          </motion.div>
          
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: '200px' }}
            transition={{
              duration: 1.5,
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "reverse"
            }}
            style={{
              height: '4px',
              backgroundColor: '#FF6B6B',
              borderRadius: '2px'
            }}
          />
          
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: 0.5,
              delay: 0.3
            }}
            style={{
              marginTop: '1rem',
              color: isDarkMode ? '#ffffff' : '#333',
              fontSize: '1.2rem',
              fontFamily: 'sans-serif'
            }}
          >
            Cargando...
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LoadingScreen; 